function isObject(variable: unknown): variable is object {
	if (variable === null) {
		return false
	}
	return typeof variable === 'object' || typeof variable === 'function'
}

// use a simple version of deepEqual without relying on lodash
// we only cover primitives, arrays and plain objects
export function quickDeepEqual(obj1: unknown, obj2: unknown): boolean {
	if (obj1 === obj2) {
		return true
	}

	if (!isObject(obj1) || !isObject(obj2)) {
		return obj1 === obj2
	}

	if (Array.isArray(obj1)) {
		if (!Array.isArray(obj2)) {
			return false
		}
		if (obj1.length !== obj2.length) {
			return false
		}
		return obj1.every((item, index) => {
			return quickDeepEqual(item, obj2[index])
		})
	}

	if (Object.keys(obj1).length !== Object.keys(obj2).length) {
		return false
	}

	for (const key in obj1) {
		if (!(key in obj2)) {
			return false
		}
		// @ts-expect-error no types for typing this
		if (!quickDeepEqual(obj1[key], obj2[key])) {
			return false
		}
	}

	return true
}
